import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { obtenerCpPdf } from "../services/pagosService";

// Muestra el PDF real del complemento de pago (el mismo que se genera y adjunta
// al enviarlo por correo, vía ComplementoPagoPdfGenerator) — así lo impreso
// siempre es idéntico a lo que se manda por email, sin mantener dos plantillas.
export default function CpPrintPage() {
  const { folio, empresa } = useParams();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let url;
    let cancelled = false;
    (async () => {
      try {
        const blob = await obtenerCpPdf(Number(folio), Number(empresa));
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setPdfUrl(url);
      } catch {
        if (!cancelled) setError("No se pudo cargar el complemento de pago.");
      }
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [folio, empresa]);

  if (error) return <div className="print-page-pad print-error">{error}</div>;
  if (!pdfUrl) return <div className="print-page-pad">Cargando complemento…</div>;

  return (
    <iframe
      title="Complemento de pago"
      src={pdfUrl}
      style={{ width: "100vw", height: "100vh", border: "none" }}
      onLoad={(e) => {
        try {
          e.target.contentWindow.focus();
          e.target.contentWindow.print();
        } catch {
          // Si el navegador bloquea el auto-print, el usuario igual puede
          // imprimir desde los controles nativos del visor de PDF.
        }
      }}
    />
  );
}
